module.exports = __webpack_public_path__ + "img/ow-news.2cacab99.jpg";